import React, { Component } from 'react';
import './styles.scss';
import PropTypes from 'prop-types'

class PageToolbar extends Component {

  render() {
    return (
      <div className={"PageToolbar PageToolbar-" + this.props.type}>
        <div className="container">
          {this.props.children}
        </div>
      </div>
    );
  }
}

PageToolbar.defaultProps = {
  type: 'default'
}

PageToolbar.propTypes = {
  type: PropTypes.string
}
export default PageToolbar;
